import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Grid } from '@material-ui/core';
import { Field } from 'react-final-form';
import FormTextField from '../../form/FormTextField';
import Pesel from '../../../utils/pesel';
import PhoneNumber from './PhoneNumber';
import TerytAddress from './TerytAddress';
import FormBirthDateField from '../../form/FormBirthDateField';
import PeselFragment from '../../form/PeselFragmentField';
import FormAutocompleteField from '../../form/FormAutocompleteField';
import TechnikaItAddress from './TechnikaItAddress';

const required = value => value ? undefined : 'Pole jest wymagane';
const pesel = value => new Pesel(value).isValid() ? undefined : 'Numer pesel nie jest prawidłowy';
const requiredPesel = value => required(value) || new Pesel(value).isValid() ? undefined : 'Numer pesel nie jest prawidłowy';

const VoterData = ({ streetsAutocomplete, streetsAutocompleteData, terytEnabled,
  terytFilter, voterRequiredData, change,
  actions, phoneVerificationEnabled, values, verificationMethodId, readonly }) => {
  return (
    <div>
      {voterRequiredData.firstName && <div><Field
        name="respondent.firstName"
        component={FormTextField}
        label="Imię"
        validate={voterRequiredData.firstNameOptional ? undefined : required}
        helperText={voterRequiredData.firstNameDescription}
        disabled={readonly}
      /></div>}
      {voterRequiredData.secondName && <div><Field
        name="respondent.secondName"
        component={FormTextField}
        label="Drugie imię"
        validate={voterRequiredData.secondNameOptional ? undefined : required}
        helperText={voterRequiredData.secondNameDescription}
      /></div>}
      {voterRequiredData.lastName && <div><Field
        name="respondent.lastName"
        component={FormTextField}
        label="Nazwisko"
        fullWidth
        validate={voterRequiredData.lastNameOptional ? undefined : required}
        helperText={voterRequiredData.lastNameDescription}
      /></div>}
      {voterRequiredData.address ? <React.Fragment>
        {terytEnabled
          ? <TerytAddress
              voterRequiredData={voterRequiredData}
              change={change}
              filter={terytFilter}
              addressRestrictedToCities={voterRequiredData.addressRestrictedToCities || []}
          />
          : streetsAutocomplete && streetsAutocompleteData
            ? <TechnikaItAddress
              voterRequiredData={voterRequiredData}
              change={change}
              streetsAutocompleteData={streetsAutocompleteData}
              cityId={values ? values.cityId : null}
              addressRestrictedToCities={voterRequiredData.addressRestrictedToCities || []}
            />
            : <div>
              <div>
                <Field
                  name="respondent.address"
                  component={FormTextField}
                  label="Adres zamieszkania"
                  fullWidth
                  validate={voterRequiredData.addressOptional ? undefined : required}
                />
                <Field
                  name="respondent.number"
                  component={FormTextField}
                  label="Numer"
                  validate={voterRequiredData.addressOptional ? undefined : required}
                />
                <Field
                  name="respondent.localNumber"
                  component={FormTextField}
                  label="Numer lokalu"
                />
              </div>
              <div>
                <Field
                  name="respondent.zipCode"
                  component={FormTextField}
                  label="Kod pocztowy"
                  validate={voterRequiredData.addressOptional ? undefined : required}
                />
                {voterRequiredData.addressRestrictedToCities && voterRequiredData.addressRestrictedToCities.length
                  ? <Field
                    name="respondent.city"
                    component={FormAutocompleteField}
                    label="Miejscowość"
                    placeholder="Miejscowość"
                    validate={voterRequiredData.addressOptional ? undefined : required}
                    autocompleteData={voterRequiredData.addressRestrictedToCities.map(name => ({ id: name, name }))}
                  />
                  : <Field
                    name="respondent.city"
                    component={FormTextField}
                    label="Miejscowość"
                    validate={voterRequiredData.addressOptional ? undefined : required}
                  />
                }
              </div>
            </div>}
        {voterRequiredData.addressDescription && <Typography variant="caption">{voterRequiredData.addressDescription}</Typography>}
      </React.Fragment> : null}
      <Grid container spacing={1}>
        {voterRequiredData.birthDate && <Grid item xs><Field
          name="respondent.birthDate"
          component={FormBirthDateField}
          label="Data urodzenia"
          validate={voterRequiredData.birthDateOptional ? undefined : required}
          helperText={voterRequiredData.birthDateDescription}
        /></Grid>}
      </Grid>
      {voterRequiredData.birthPlace && <Field
        name="respondent.birthPlace"
        fullWidth
        component={FormTextField}
        placeholder="Wprowadź pełną nazwę miejscowości"
        label="Miejsce urodzenia"
        validate={voterRequiredData.birthPlaceOptional ? undefined : required}
        helperText={voterRequiredData.birthPlaceDescription}
      />}
      <Grid container spacing={1}>
        {voterRequiredData.motherName && <Grid item xs><Field
          name="respondent.motherName"
          component={FormTextField}
          label="Imię matki"
          validate={voterRequiredData.motherNameOptional ? undefined : required}
          helperText={voterRequiredData.motherNameDescription}
        /></Grid>}
        {voterRequiredData.fatherName && <Grid item xs><Field
          name="respondent.fatherName"
          component={FormTextField}
          label="Imię ojca"
          validate={voterRequiredData.fatherNameOptional ? undefined : required}
          helperText={voterRequiredData.fatherNameDescription}
        /></Grid>}
        {voterRequiredData.motherLastName && <Grid item xs><Field
          name="respondent.motherLastName"
          component={FormTextField}
          label="Nazwisko rodowe matki"
          fullWidth
          validate={voterRequiredData.motherLastNameOptional ? undefined : required}
          helperText={voterRequiredData.motherLastNameDescription}
        /></Grid>}
        {voterRequiredData.citizenship && <Grid item xs><Field
          name="respondent.citizenship"
          component={FormTextField}
          label="Obywatelstwo"
          validate={voterRequiredData.citizenshipOptional ? undefined : required}
          helperText={voterRequiredData.citizenshipDescription}
        /></Grid>}
        {voterRequiredData.pesel && <Grid item xs><Field
          name="respondent.pesel"
          component={FormTextField}
          label="Pesel"
          validate={voterRequiredData.peselOptional ? pesel : requiredPesel}
          helperText={voterRequiredData.peselDescription}
        /></Grid>}
      </Grid>
      {voterRequiredData.peselFragment && <div>
        <Field
          name="respondent.peselFragment"
          component={PeselFragment}
          label="Numer PESEL - wybrane cyfry"
          peselFragmentMask={voterRequiredData.peselFragmentMask}
          validate={voterRequiredData.peselFragmentOptional ? undefined : required}
          helperText={voterRequiredData.peselFragmentDescription}
        />
      </div>}
      {voterRequiredData.cityCard && <div>
        <Field
          name="respondent.cityCard"
          component={FormTextField}
          label="Numer karty"
          validate={voterRequiredData.cityCardOptional ? undefined : required}
          helperText={voterRequiredData.cityCardDescription}
        />
      </div>}
      {
        voterRequiredData.phoneNumber && <div>
          <PhoneNumber
            voterRequiredData={voterRequiredData}
            change={change}
            phoneVerificationEnabled={phoneVerificationEnabled}
            onStartVerification={phoneVerificationEnabled ? actions.startPhoneNumberVerification : null}
            helperText={voterRequiredData.phoneNumberDescription}
            verificationMethodId={verificationMethodId}
          />
        </div>
      }
    </div>
  );
};

VoterData.defaultProps = {
  restrictedToCities: []
};

VoterData.propTypes = {
  voterRequiredData: PropTypes.object.isRequired,
  streetsAutocomplete: PropTypes.bool.isRequired,
  streetsAutocompleteData: PropTypes.array,
  terytEnabled: PropTypes.bool,
  change: PropTypes.func.isRequired,
  terytFilter: PropTypes.string,
  phoneVerificationEnabled: PropTypes.bool.isRequired,
  actions: PropTypes.object,
  values: PropTypes.object,
  verificationMethodId: PropTypes.string,
  restrictedToCities: PropTypes.array,
  readonly: PropTypes.bool,
};

export default VoterData;



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/responderVerification/VoterData.js